import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IProps } from './models';
import { SmeFormIterator as Component } from './sme-form-iterator';

/** @widgetName SmeFormIterator */
export const SmeFormIterator = createWidget<unknown, IProps>()(Component);
